export const CommunicationReportItemActionKind = {
  ARCHIVED: 'archived',
  DELETED: 'deleted',
} as const;

export type CommunicationReportItemActionKind =
  (typeof CommunicationReportItemActionKind)[keyof typeof CommunicationReportItemActionKind];

export interface CommunicationReportActionsState {
  actionsByItemId: Record<string, CommunicationReportItemActionKind>;
  pendingByItemId: Record<string, boolean>;
}

export const INITIAL_COMMUNICATION_REPORT_ACTIONS_STATE: CommunicationReportActionsState =
  {
    actionsByItemId: {},
    pendingByItemId: {},
  };

export interface CommunicationReportActionsActions {
  markActionPending: (itemId: string) => void;
  markActionCompleted: (
    itemId: string,
    kind: CommunicationReportItemActionKind,
  ) => void;
  clearActionPending: (itemId: string) => void;
  resetItem: (itemId: string) => void;
  resetState: () => void;
  useActionFor: (
    itemId: string,
  ) => CommunicationReportItemActionKind | undefined;
  useIsPendingFor: (itemId: string) => boolean;
}

export type CommunicationReportActionsStore = CommunicationReportActionsState &
  CommunicationReportActionsActions;
